import React, { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { fileToCompressedDataUrl } from "../lib/image";

export default function EditProfile() {
  const { user, refresh } = useAuth();
  const isSeller = user?.role === "seller";
  const [name, setName] = useState(user?.name || "");
  const [storeName, setStoreName] = useState(user?.store_name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [whatsapp, setWhatsapp] = useState(user?.whatsapp || "");
  const [address, setAddress] = useState(user?.address || "");
  const [picture, setPicture] = useState(user?.picture_base64 || user?.picture || null);
  const [busy, setBusy] = useState(false);

  const onPic = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    try { setPicture(await fileToCompressedDataUrl(f, 600, 0.7)); } catch {}
  };
  const save = async () => {
    setBusy(true);
    try {
      const body = { name: name.trim(), phone: phone.trim(), whatsapp: whatsapp.trim(), address: address.trim() };
      if (isSeller) body.store_name = storeName.trim();
      if (picture && picture.startsWith("data:")) body.picture_base64 = picture;
      await api("/auth/profile", { method: "PUT", body: JSON.stringify(body) });
      await refresh();
      toast.success("تم حفظ التغييرات");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="تعديل الملف الشخصي" />
      <div className="flex flex-col items-center">
        <label className="relative cursor-pointer" data-testid="edit-picture">
          {picture ? <img src={picture} alt="" className="w-24 h-24 rounded-3xl object-cover" /> : <div className="w-24 h-24 rounded-3xl bg-[#7C5CFF] flex items-center justify-center text-white text-3xl font-black">{(name || "?")[0]}</div>}
          <span className="absolute bottom-0 end-0 w-8 h-8 rounded-xl bg-[#FF3D5A] flex items-center justify-center border-2 border-white"><Upload size={14} className="text-white" /></span>
          <input type="file" accept="image/*" className="hidden" onChange={onPic} />
        </label>
      </div>
      <L>الاسم</L><In t="ep-name" v={name} on={setName} />
      {isSeller && <><L>اسم المتجر</L><In t="ep-store" v={storeName} on={setStoreName} /></>}
      <L>رقم الهاتف</L><In t="ep-phone" v={phone} on={setPhone} />
      <L>واتساب</L><In t="ep-whatsapp" v={whatsapp} on={setWhatsapp} />
      <L>العنوان</L><In t="ep-address" v={address} on={setAddress} />
      <button data-testid="save-profile" disabled={busy} onClick={save} className="w-full h-13 py-4 rounded-2xl bg-[#FF3D5A] text-white font-black mt-6 disabled:opacity-60">{busy ? "..." : "حفظ"}</button>
    </div>
  );
}
function L({ children }) { return <p className="text-sm font-bold text-[#161629] mt-4 mb-1.5">{children}</p>; }
function In({ v, on, t }) { return <input data-testid={t} value={v} onChange={(e) => on(e.target.value)} className="w-full bg-white rounded-xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />; }
